import { ReactComponent as Vector } from "../vectors/FlowerDivider.svg"

const FlowerDivider = ({ fillColor = "text-gold" }) => {
  return (
    <Vector className={`mx-auto h-auto flower-divider max-w-full fill-current ${fillColor}`} />
  );
};

export default FlowerDivider